// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/activities.js'; import './autoload/ajaxcalls.js'; import './autoload/customfunctions.js'; import './autoload/flickitys.js'; import './autoload/menus.js'; import './autoload/modules.js'; import './autoload/woocommerce.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

// Autoload folder
import customfunctions from './autoload/customfunctions';
import flickitys from './autoload/flickitys';
import menus from './autoload/menus';
import modules from './autoload/modules';
import woocommerce from './autoload/woocommerce';

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebook, faTwitter, faWhatsapp, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { 
  faChevronDown,
  faChevronUp,
  faShoppingCart,
  faUser, faSearch,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faCheck,
  faArrowCircleLeft,
  faSearchPlus,
  faClock,
  faAt,
  faEye,
  } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(
  faFacebook,
  faTwitter,
  faWhatsapp,
  faLinkedin,
  faInstagram,
  faChevronDown,
  faChevronUp,
  faShoppingCart,
  faUser,
  faSearch,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faCheck,
  faArrowCircleLeft,
  faSearchPlus,
  faClock,
  faAt,
  faEye
  );

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  customfunctions,
  flickitys,
  menus,
  modules,
  woocommerce,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js